import { render, staticRenderFns } from "./CompanyContactsTable.vue?vue&type=template&id=f158f3c4&"
import script from "./CompanyContactsTable.vue?vue&type=script&lang=js&"
export * from "./CompanyContactsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/CompanyContactsTable.vue
// module id = null
// module chunks = 